// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jn-3";
export var downloadButton = "_jn-4";
export var fileContainer = "_jn-9 _jn-7";
export var fileContainerBase = "_jn-7";
export var fileContainerBaseSm = "_jn-a _jn-7";
export var fileContainerFixedHeight = "_jn-8 _jn-7";
export var fileContainerFixedHeightSm = "_jn-c _jn-a _jn-7";
export var fileContainerSm = "_jn-b _jn-a _jn-7";
export var fileInfo = "_jn-5";
export var fileInfoWidthRestricted = "_jn-6";
export var fileType = "_jn-1";
export var fileTypeName = "_jn-2";
export var fileTypeSm = "_jn-d _jn-1";
export var image = "_jn-0";
export var link = "_jn-f";
export var overflowEllipsis = "_jn-e";